import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks a request as background / fire-and-forget. Interceptors must not surface any
 * user-facing feedback for it: no error toast and no session-expired dialog.
 */
export const SILENT_REQUEST = new HttpContextToken<boolean>(() => false);

export function silentRequestContext(): HttpContext {
  return new HttpContext().set(SILENT_REQUEST, true);
}
